module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/14ff92731b3e54b249ce2d428a3f0f95.png";